/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
 
/* eslint-disable no-console */
/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 */
 
(function() {
    'use strict';
    
    // Esperar a que el DOM esté completamente cargado
    document.addEventListener('DOMContentLoaded', function() {
        // Seleccionar todos los bloques de apartamentos
        const blocks = document.querySelectorAll('.apartamentos-selector');
        
        blocks.forEach((block, blockIndex) => {
            // Seleccionar elementos dentro de este bloque específico
            const apartamentosItems = block.querySelectorAll('.apartamento-item');
            const imagenesContenedor = block.querySelector('.images-container');
            
            if (!apartamentosItems.length || !imagenesContenedor) {
                return; // Si no hay elementos, salir
            }
            
            // Buscar todas las imágenes dentro del contenedor
            const todasLasImagenes = imagenesContenedor.querySelectorAll('.imagen-apartamento');
            
            // Encontrar la imagen por defecto (la primera activa)
            let imagenDefault = null;
            const imagenDefaultElement = imagenesContenedor.querySelector('.imagen-apartamento.imagen-activa img');
            
            if (imagenDefaultElement) {
                imagenDefault = {
                    src: imagenDefaultElement.src,
                    alt: imagenDefaultElement.alt
                };
            }
            
            // Variable para controlar el timeout
            let timeoutId = null;
            let isHovering = false;
            
            // Función para cambiar la imagen
            function cambiarImagen(imagenUrl, imagenAlt) {
                // Ocultar todas las imágenes
                todasLasImagenes.forEach(imgCont => {
                    imgCont.classList.remove('imagen-activa');
                    imgCont.classList.add('imagen-oculta');
                });
                
                // Encontrar y mostrar la imagen correspondiente
                const imagenTarget = Array.from(todasLasImagenes).find(imgCont => {
                    const img = imgCont.querySelector('img');
                    return img && img.src === imagenUrl;
                });
                
                if (imagenTarget) {
                    imagenTarget.classList.remove('imagen-oculta');
                    imagenTarget.classList.add('imagen-activa');
                }
            }
            
            // Función para restaurar la imagen por defecto
            function restaurarImagenPorDefecto() {
                if (imagenDefault) {
                    cambiarImagen(imagenDefault.src, imagenDefault.alt);
                } else if (todasLasImagenes.length > 0) {
                    // Mostrar la primera imagen
                    todasLasImagenes.forEach((imgCont, idx) => {
                        if (idx === 0) {
                            imgCont.classList.remove('imagen-oculta');
                            imgCont.classList.add('imagen-activa');
                        } else {
                            imgCont.classList.remove('imagen-activa');
                            imgCont.classList.add('imagen-oculta');
                        }
                    });
                }
            }
            
            // Añadir eventos a cada apartamento
            apartamentosItems.forEach((item, index) => {
                // Obtener la URL de la imagen desde el atributo data-imagen
                const imagenUrl = item.getAttribute('data-imagen');
                
                if (!imagenUrl) {
                    return; // Si no hay imagen, no hacer nada
                }
                
                // Evento mouseenter - cambiar imagen
                item.addEventListener('mouseenter', function() {
                    isHovering = true;
                    
                    // Limpiar timeout anterior si existe
                    if (timeoutId) {
                        clearTimeout(timeoutId);
                        timeoutId = null;
                    }
                    
                    // Cambiar inmediatamente a la imagen correspondiente
                    const imagenAlt = `${this.querySelector('.apartamento-nombre')?.textContent || 'Apartamento'} - ${this.querySelector('.apartamento-descripcion')?.textContent || ''}`;
                    cambiarImagen(imagenUrl, imagenAlt);
                });
                
                // Evento mouseleave - programar retorno a imagen por defecto
                item.addEventListener('mouseleave', function() {
                    isHovering = false;
                    
                    // Esperar un poco antes de restaurar (para evitar parpadeos)
                    timeoutId = setTimeout(function() {
                        // Solo restaurar si no se está haciendo hover en otro apartamento
                        if (!isHovering) {
                            restaurarImagenPorDefecto();
                        }
                    }, 100); // 100ms de delay
                });
                
                // Añadir estilo de cursor para indicar interactividad
                item.style.cursor = 'pointer';
                
            });
            
            // También restaurar cuando se sale del bloque completo
            block.addEventListener('mouseleave', function() {
                isHovering = false;
                
                timeoutId = setTimeout(function() {
                    restaurarImagenPorDefecto();
                }, 100);
            });
            
            // Limpiar timeout cuando la página se cierre/navegue
            window.addEventListener('beforeunload', function() {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
            });
        });
        
    });
    
})();
/* eslint-enable no-console */
